import {
  BaseQueryApi,
  createApi,
  FetchArgs,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';
import { RootState } from './store';
import { logout } from '../features/login/authSlice';
import { ISiteSettings } from '@topshots/core-models';
// import axios from 'axios';
// import type { AxiosRequestConfig, AxiosError } from 'axios';

// const axiosBaseQuery =
//   (
//     { baseUrl }: { baseUrl: string } = { baseUrl: '' }
//   ): BaseQueryFn<
//     {
//       url: string;
//       method: AxiosRequestConfig['method'];
//       data?: AxiosRequestConfig['data'];
//       params?: AxiosRequestConfig['params'];
//     },
//     unknown,
//     unknown
//   > =>
//   async ({ url, method, data, params }) => {
//     try {
//       const result = await axios({ url: baseUrl + url, method, data, params });
//       return { data: result.data };
//     } catch (axiosError) {
//       const err = axiosError as AxiosError;
//       return {
//         error: {
//           status: err.response?.status,
//           data: err.response?.data || err.message,
//         },
//       };
//     }
//   };
// Define a service using a base URL and expected endpoints

const authHandlingBaseQuery = () => {
  const base = fetchBaseQuery({
    baseUrl: `${
      process.env.NX_PUBLIC_TOPSHOTS_BASE_URL ?? 'https://api.topshots.org.uk'
    }/api`,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;

      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }

      return headers;
    },
  });
  return async (
    args: string | FetchArgs,
    api: BaseQueryApi,
    extraOptions: object
  ) => {
    const { error, data } = await base(args, api, extraOptions);
    if (error) {
      if ((error as { originalStatus?: number })?.originalStatus === 401) {
        logout();
      }
      return { error: { status: error.status, data: error.data } };
    }

    return { data };
  };
};

export const tagTypes = [
  'Enquiries',
  'Products',
  'ProductSelectorTemplates',
  'SiteSettings',
  'Orders',
  'Events',
  'Users',
  'Tasks',
  'Albums',
  'Images',
  'EventCover',
  'AlbumCover',
  'Archives',
  'Watermark',
  'Coupons',
  'OrderSummaries',
  'OrderTotals',
  'EventTurnover',
  'Staging',
  'AccountBilling',
];

export const topshotsAPI = createApi({
  reducerPath: 'topshotsAPI',
  tagTypes,
  baseQuery: authHandlingBaseQuery(),
  endpoints: (builder) => ({
    getSiteSettings: builder.query<ISiteSettings, void>({
      query: () => `sitesettings`,
      providesTags: ['SiteSettings'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSiteSettingsQuery, util } = topshotsAPI;
